import { MessageFlashOutlineIcon } from './MessageFlashOutlineIcon';

/**
 * author: Google
 * id DA7B2430-9A55-42D5-AE19-92E108303E79
 * name message-flash-outline
 * version: 5.5.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/message-flash-outline.svg
 * tags
 */
export const MessageQuickOutlineIcon = MessageFlashOutlineIcon;
export default MessageQuickOutlineIcon